import { render, staticRenderFns } from "./CoralsolOcorrencias.vue?vue&type=template&id=5bd26819&"
import script from "./CoralsolOcorrencias.vue?vue&type=script&lang=js&"
export * from "./CoralsolOcorrencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports